import React, { Component } from 'react';
import { connect } from 'react-redux';
import './privacyPolicy.scss';
import { Button } from 'antd';
import { fromValidate, history } from '../../../helpers'
import Header from "../../../layout/DefaultLayout/Header";
import FAQ from "../../../images/faq-banner.png";

class Faq extends Component {

   constructor(props) {
      super(props);
      this.state = {
         formError: {},
         formSubmit: false,
         user: {},
         userNumber: '****7890',
         isSuccess: true,
      }
   }


   render() {
      const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
      return (
         <div>
            <Header></Header>
            <div>
               <img src={FAQ} className="about-background-img" alt="" />
            </div>

            <div className='policy-container'>
               <div className="main-heading-txt">Question And Answers</div>
               <div className="containt-container">
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  <div className="heading-txt">What is Lorem Ipsum?</div>
                  <div className="sub-heading-txt">Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                  Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</div>
                  
               </div>

            </div>
         </div>
      )
   }
}

function mapStateToProps(state) {
   const { user } = state.authentication;
   return {
      user,
   }
}
export default connect(mapStateToProps)(Faq);